export const SESSION_STORAGE_NAME = 'user::store';
export const COOKIE_NAME = 'bpdAccountToken';
export const COOKIE_EXPIRES = Math.floor(365 / 2);

export const MY_HOME_IFRAME_MESSAGE_EVENT_NAME = 'myHomeIframe::messageEvent';
export const MY_HOME_IFRAME_LOGIN_MESSAGE_NAME = 'myhomeiframe';
export const WEBSITE_IFRAME_LOGIN_MESSAGE_NAME = 'accountLogin';

export const GET_USER_INFO_ENDPOINT = '/umbraco/surface/account/get';
export const ADD_TO_WISHLIST_ENDPOINT = '/umbraco/surface/account/addtowishlist';
export const REMOVE_FROM_WISHLIST_ENDPOINT = '/umbraco/surface/account/removefromwishlist';
